module.exports = __webpack_public_path__ + "img/changeGrooves-2@2x.9fd9bcc.webp";